import { FormControl, FormGroup, FormRecord } from '@angular/forms';
import { ClientGroupCode } from '@domgen/dgx-fe-common';
import { GroupMarketingPreferencesFormField } from '../../models/group-marketing-preferences/group-marketing-preferences-form-field.enum';
import { GroupMarketingPreferencesForm } from '../../models/group-marketing-preferences/group-marketing-preferences-form.interface';
import { mockGroupMarketingPreferenceForm } from '../group-marketing-preference/group-marketing-preference-form.mock';

export const mockGroupMarketingPreferencesForm: GroupMarketingPreferencesForm =
  {
    [GroupMarketingPreferencesFormField.GroupMarketingConsent]: new FormControl(
      true
    ),
    [GroupMarketingPreferencesFormField.GroupMarketingPreferences]:
      new FormRecord({
        [ClientGroupCode.Beko]: new FormGroup(mockGroupMarketingPreferenceForm),
      }),
  };
